






































































































































































































































































































import Vue from "vue";
import data from "./data.json";

export default Vue.extend({
	name: "DataPrivacyComp",
	data: () => ({
		data: data
	})
});
